import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.card {
    background: #ffffff;
    padding: calc(8px * 2);
    display: inline-block;
    min-height: 48px;
    margin: 12px 2px;
    position: relative;
    width: calc(100% - (2 * 2px));
}
@media (max-width: 1080px) {
    .card.scroll-card {
        overflow-x: scroll;
    }
}
`;

export default styles;